export const cohortChurnConf = [
  {
    field: 'time',
    title: 'Time'
  }
];
